<i18n>
{
  "en": {
    "title": "2018 Sustainability Priorities",
    "description": "We look forward to continued and strong sustainable growth moving forward. Learn about our goals for organic, top-line growth as well as EBITA margin expansion, and hear from Emmanuel Babeau, Deputy CEO & CFO of Schneider Electric, as he describes the performance goals we are holding ourselves accountable responsible for meeting.",
    "lookingAhead": {
      "section": "Looking Ahead",
      "title": "2018 Priorities",
      "priorities": {
        "quote": {
          "para": "In working for a more sustainable world, we not only ensure a healthier planet for future generations, we also promote innovation and prosperity here and now. What’s good for the climate is good for the economy.",
          "title": "Chairman and CEO",
          "company": "Schneider Electric"
        },
        "txt": {
          "title": "Sustainable growth",
          "p1": "It was a great year for Schneider Electric, with healthy performance on our Planet &amp; Society barometer and strong growth for our business.",
          "p2": "Our sales accelerated, boosted by the delivery of complete solutions of efficiency and productivity and the adoption of EcoStruxure as the platform of integration and collaboration.",
          "p3": "We increased organic revenue 3.2 percent, launched more than 100 new products, and acquired new companies that strengthen our position as the global specialist in energy management and automation."
        },
        "snapshot1": {
          "txt": "In a positive environment, the group targets to deliver strong organic growth of adjusted EBITA in 2018, around the high-end of the +4% to +7% bracket earlier communicated as the average yearly objective for 2017 – 2019. To deliver this strong performance the Group will balance both levers of organic top-line growth and EBITA margin expansion. Therefore, for 2018, the Group will target:",
          "card1": {
            "title": "An organic top-line growth between +3% to +5%"
          },
          "card2": {
            "title": "An organic EBITA margin expansion toward the upper end of the +20 bps to +50 bps range targeted as yearly average improvement for 2017 – 2019"
          }
        }
      }
    }
  },
  "fr": {
    "title": "2018 Sustainability Priorities",
    "description": "We look forward to continued and strong sustainable growth moving forward. Learn about our goals for organic, top-line growth as well as EBITA margin expansion, and hear from Emmanuel Babeau, Deputy CEO & CFO of Schneider Electric, as he describes the performance goals we are holding ourselves accountable responsible for meeting.",
    "lookingAhead": {
      "section": "Anticiper demain",
      "title": "Priorités 2018",
      "priorities": {
        "snapshot1": {
          "txt": "Dans une conjoncture favorable, notre priorité pour 2018 est de continuer à générer une croissance rentable. Nous visons une croissance organique de notre EBITA ajusté en 2018, autour de la borne haute de la fourchette de +4  à +7 %, communiquée précédemment  comme objectif annuel moyen pour la période 2017-2019. Pour réaliser cette performance, le Groupe misera sur deux leviers complémentaires : la croissance organique du chiffre d’affaires et l’amélioration organique de la marge d’EBITA ajusté. Par conséquent, pour 2018, le Groupe tablera sur :",
          "card1": {
            "title": "une croissance organique du chiffre d'affaires entre +3 % et +5 % ; et"
          },
          "card2": {
            "title": "une amélioration organique  de la marge d’EBITA ajusté située vers le haut de la fourchette de +20 à +50 points de base, fourchette correspondant à l'amélioration annuelle moyenne visée pour la période 2017-2019."
          }
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/looking-ahead/looking-ahead-2018-priorities-hero-lores.jpg')" :hiResSrc="require('@/assets/img/looking-ahead/looking-ahead-2018-priorities-hero.jpg')" chapter="07" :section="$t('lookingAhead.section')" :title="$t('lookingAhead.title')" />

    <section class="m-t-120 m-b-120">
      <TxtMedia>
        <div slot="main-content">
          <p v-html="$t('lookingAhead.priorities.snapshot1.txt')"/>
          <ul>
            <li v-html="$t('lookingAhead.priorities.snapshot1.card1.title')"></li>
            <li v-html="$t('lookingAhead.priorities.snapshot1.card2.title')"></li>
          </ul>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/looking-ahead/GettyImages-588551173.jpg')" alt="">
      </TxtMedia>
    </section>

    <!-- <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <p v-html="$t('lookingAhead.priorities.snapshot1.txt')"/>
        </div>
        <SnapshotCard :double="true">
          <div class="t-hr"></div>
          <h3 v-html="$t('lookingAhead.priorities.snapshot1.card1.title')"/>
        </SnapshotCard>
        <SnapshotCard :double="true">
          <div class="t-hr"></div>
          <h3 v-html="$t('lookingAhead.priorities.snapshot1.card2.title')"/>
        </SnapshotCard>
      </Snapshot>
    </section> -->

   <div class="l-content">
      <FooterNav
        nextRoute="LookingAhead_SustainabilityApproach"
        prevRoute="LookingAhead_Overview" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import TxtMedia from '@/components/TxtMedia'

export default {
  name: 'LookingAhead_2018Priorities',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    ImageFull,
    Snapshot,
    SnapshotCard,
    TxtMedia
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/looking-ahead/2018-priorities.vue